<template>
  <div>
    <el-card class="box-card" v-auth="'/newsList/pageList'">
      <el-form
        ref="searchForm"
        :model="searchForm"
        :label-width="formLabelWidth"
      >
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="标题" prop="query">
              <el-input
                clearable
                v-model="searchForm.title"
                placeholder="请输入标题"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="7">
            <el-form-item label="创建时间" prop="createTime">
              <el-date-picker
                style="width: 100%"
                v-model="searchForm.period"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4" style="float: right">
            <el-button-group style="float: right">
              <el-button type="primary" @click="pageList" icon="el-icon-search"
                         v-auth="'/newsList/pageList'"
                >查询</el-button
              >
              <el-button
                type="primary"
                @click="reset('searchForm')"
                icon="el-icon-refresh"
                v-auth="'/newsList/reset'"
                >重置</el-button
              >
            </el-button-group>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <!-- <router-link :to="{ path: '/sendNews' }">
        <el-button type="primary" icon="el-icon-plus">去发布消息</el-button>
      </router-link> -->
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="sendNewsVisible = true"
        v-auth="'/newsList/sendNews'"
        >去发布消息</el-button
      >

      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px"
        v-loading="Loading"
        border
        @selection-change="selectionChange"
        rowClassName="table-list"
      >
        <el-table-column show-overflow-tooltip label="标题">
          <template slot-scope="scope">
            <span
              class="mainColor"
              @click="goDetial(scope.row)"
              v-html="scope.row.title"
            >
            </span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="operator"
          label="创建人"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="createTime"
          width="200px"
          label="创建时间"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="120px">
          <template slot-scope="scope">
            <span class="mainColor" @click="goEdite(scope.row)" v-auth="'/newsList/goEdite'">编辑 </span>
            <span class="mainColor" @click="goDelete(scope.row)" v-auth="'/newsList/goDelete'">删除 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="!Loading"
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
    <!--消息中心-->
    <el-dialog
      title="消息详情"
      :visible.sync="newsVisible"
      width="30%"
      :footer="null"
    >
      <el-row>
        <el-col class="mb20">标题：{{ newsDetail.title }}</el-col>
        <el-col>
          内容：
          <span v-html="newsDetail.content"></span
        ></el-col>
      </el-row>
    </el-dialog>
    <!--编辑-->
    <el-dialog title="编辑" :visible.sync="editeVisible" width="60%">
      <el-form
        ref="rowForm"
        :model="rowForm"
        :rules="rules"
        label-width="100px"
        class="news-form"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="rowForm.title"></el-input>
        </el-form-item>

        <el-form-item label="内容" prop="content">
          <quill-editor
            ref="quillEditor"
            v-model="rowForm.content"
            class="myQuillEditor"
            :options="editorOption"
          />
        </el-form-item>

        <el-form-item label="弹框推送" prop="isSend">
          <el-switch
            v-model="rowForm.isSend"
            :active-value="0"
            :inactive-value="1"
          ></el-switch>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editeVisible = false">取 消</el-button>
        <el-button type="primary" @click="editeSure">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 发布消息 -->
    <el-dialog
      title="消息发布"
      :visible.sync="sendNewsVisible"
      width="70%"
      :footer="null"
      destroy-on-close
    >
      <sendNews ref="sendRef" @handleClose="handleClose"></sendNews>
    </el-dialog>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import quillConfig from "../../upload/quill-config";
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";

Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
import sendNews from "./sendNews";
export default {
  name: "news-list",
  components: { sendNews },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      if (from.path == "/queryDetialNew") {
        vm.pageList();
      }
    });
  },

  data () {
    return {
      editorOption: quillConfig,
      rowForm: {},
      sendNewsVisible: false,
      editeVisible: false,
      newsVisible: false,
      newsDetail: "",
      stateList: [
        {
          label: "已解答",
          value: "0",
        },
        {
          label: "待解答",
          value: "1",
        },
      ],
      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          { min: 3, max: 15, message: "长度在 3 到 15 个字符", trigger: "blur" },
        ],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
      page: {
        rows: [],
        total: null,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },

      Loading: false,
      searchForm: {
        // agentIdList: null,
        period: null,
        title: "",
        admin: 1,
      },
      regionArray: [],
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/questionQuery/upload`,
      fileList: [],
      loading: false,
    };
  },
  methods: {
    handleClose (value) {
      this.sendNewsVisible = value
      this.pageList()
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
    },
    pageList () {
      this.Loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;

      this.api.newsCenter
        .pageList(this.searchForm)
        .then((result) => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.Loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goEdite (row) {
      this.editeVisible = true;
      this.rowForm = row;
    },

    editeSure () {
      this.api.newsCenter
        .updateNotice({
          title: this.rowForm.title,
          content: this.rowForm.content,
          isSend: this.rowForm.isSend,
        })
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.editeVisible = false;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goDelete (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.newsCenter
            .deleteNotice({
              idList: [row.id],
            })
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    goDetial (row) {
      this.$router.push({
        path: "/newsDetail",
        query: { id: row.id },
      });
    },
    reset (formName) {
      // this.$refs[formName].resetFields();
      this.searchForm.title = "";
      this.searchForm.period = null;
      //   this.searchForm.agentIdList = null;

      this.page = {
        rows: [],
        total: null,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
  },

  mounted () {
    this.pageList();
  },
  created () {
    this.api.newsCenter
      .getAgentInfoList()
      .then((result) => {
        if (result.success) {
          this.regionArray = result.data;
        } else {
          this.$message.error(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style lang="less" scoped>
.state {
  text-align: center;
  span {
    padding: 4px 8px;
    color: #fff;
    border-radius: 4px;
    margin-right: 10px;
  }
}

.news-form {
  width: 70%;
}
.mb20 {
  margin-bottom: 20px;
}
</style>
<style lang="less">
.table-list {
  td {
    img {
      width: 50px;
      height: 50px;
    }
  }
  .mainColor img {
    display: none;
  }
}

.myQuillEditor .ql-editor {
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/newsCenter/newsList.vue